import { computed } from 'vue';
import { featureFlagService } from '@/models/feature-flag';
import { filtersToQueryParams } from '@/utils/filters/query';
function newInvoiceFilterEnabled() {
    return featureFlagService.can('new-invoice-filter-modal');
}
export function useNewInvoiceFilter() {
    return computed(newInvoiceFilterEnabled);
}
export function filteredQueryIndexLink(name, clauses, legacyQuery) {
    if (!newInvoiceFilterEnabled()) {
        return { name, query: legacyQuery };
    }
    return { name, query: filtersToQueryParams({ filters: clauses }) };
}
export function invoiceIndexLink(clauses, legacyQuery) {
    return filteredQueryIndexLink('invoice.index', clauses, legacyQuery);
}
export function clientIndexLink(clauses) {
    return { name: 'client.index', query: filtersToQueryParams({ filters: clauses }) };
}
export function workActIndexLink(clauses) {
    return { name: 'work-act.index', query: filtersToQueryParams({ filters: clauses }) };
}
export function commercialSuggestionIndexLink(clauses, legacyQuery) {
    return filteredQueryIndexLink('commercial-suggestion.index', clauses, legacyQuery);
}
export function sipStatementsIndexLink(clauses) {
    return { name: 'sip-statements.payments.index', query: filtersToQueryParams({ filters: clauses }) };
}
export function expenseDocumentsIndexLink(clauses) {
    return { name: 'expense-documents.index', query: filtersToQueryParams({ filters: clauses }) };
}
export function productIndexLink(clauses, legacyQuery) {
    return filteredQueryIndexLink('product.index', clauses, legacyQuery);
}
export function compensationIndexLink(clauses) {
    return { name: 'compensation.index', query: filtersToQueryParams({ filters: clauses }) };
}
// Expenses exist as two modules with separate lists, so every link into "the expense list"
// has to resolve which one the company is on.
export function expenseIndexRouteName() {
    return featureFlagService.can('expense-new') ? 'expense-new.index' : 'expense.index';
}
export function useExpenseIndexRouteName() {
    return computed(expenseIndexRouteName);
}
// Only the new expense list has adopted the v2 surface — the legacy one filters from ?query
// alone and would drop a clause it doesn't read, so clauses travel only when it is the target.
export function expenseIndexLink(clauses, legacyQuery) {
    if (!featureFlagService.can('expense-new')) {
        return { name: 'expense.index', query: legacyQuery };
    }
    return filteredQueryIndexLink('expense-new.index', clauses, legacyQuery);
}
// reactive variant for a single static link (dashboard-style). for per-row / dynamic
//  links, call invoiceIndexLink() directly in the template instead.
export function useInvoiceIndexLink(clauses, legacyQuery) {
    return computed(() => invoiceIndexLink(clauses, legacyQuery));
}
